import React from 'react';
import clsx from 'clsx';
import Filter from '@/components/Filter';
import DatasetAttachmentsFilterToggles from '@/datasets/attachments/components/DatasetAttachmentsFilterToggles';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const RequestAttachmentsFilters = ({
  category,
  className,
  code,
  fluid,
}) => {
  const { filterTerm, typeFilter } = Selectors.useRequestAttachmentsFilters({ category, code });
  const updateFlags = Events.useToggleRequestAttachmentTypeFilter(category, { code });
  const updateTextFilter = Events.useUpdateRequestAttachmentTextFilter(category, { code });

  return (
    <Filter
      className={clsx('aridhia-request-attachments-filters', className)}
      filterTerm={filterTerm}
      fluid={fluid}
      updateFilter={({ value }) => updateTextFilter({ text: value })}
      label={(<DatasetAttachmentsFilterToggles typeFilter={typeFilter} onClick={updateFlags} />)}
    />
  );
};

export default RequestAttachmentsFilters;
